import {
	type AddTenantEmailSenderMutation,
	type CompleteTenantEmailSenderVerificationMutation,
	type RefreshTenantEmailSenderStatusMutation,
	type RemoveTenantEmailSenderMutation,
	type RequestTenantEmailSenderVerificationMutation,
	type SetEmailSenderAdminOnlyMutation,
	type SetTenantDefaultEmailSenderMutation
} from "~/gql/mutations/tenantEmailSenders.generated";
import {
	type GetEffectiveEmailSenderQuery,
	type GetSelectableEmailSendersQuery,
	type GetSenderDomainPolicyQuery,
	type GetTenantEmailSenderSelectionQuery,
	type GetTenantEmailSendersQuery
} from "~/gql/queries/tenantEmailSenders.generated";

export const emailSendersEndpoints = {
	AddTenantEmailSender: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: AddTenantEmailSenderMutation) => res
	},
	CompleteTenantEmailSenderVerification: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: CompleteTenantEmailSenderVerificationMutation) => res
	},
	GetEffectiveEmailSender: {
		providesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: GetEffectiveEmailSenderQuery) => res
	},
	GetSelectableEmailSenders: {
		providesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: GetSelectableEmailSendersQuery) => res
	},
	GetTenantEmailSenderSelection: {
		providesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: GetTenantEmailSenderSelectionQuery) => res
	},
	GetTenantEmailSenders: {
		providesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: GetTenantEmailSendersQuery) => res
	},
	RefreshTenantEmailSenderStatus: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: RefreshTenantEmailSenderStatusMutation) => res
	},
	RemoveTenantEmailSender: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: RemoveTenantEmailSenderMutation) => res
	},
	GetSenderDomainPolicy: {
		transformResponse: (res: GetSenderDomainPolicyQuery) => res
	},
	RequestTenantEmailSenderVerification: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: RequestTenantEmailSenderVerificationMutation) => res
	},
	SetEmailSenderAdminOnly: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: SetEmailSenderAdminOnlyMutation) => res
	},
	SetTenantDefaultEmailSender: {
		invalidatesTags: ["TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: SetTenantDefaultEmailSenderMutation) => res
	}
};
